import { mockPlayers } from "@/mocks/tablePlayers.js";
import { mockUsers } from "@/mocks/users.js";

// Centralized initial local tables scenarios (static mock data)
export const initialTables = [
  {
    id: 1,
    name: "Veterans Table",
    owner: "João",
    language: "pt-BR",
    isPrivate: false,
    password: null,
    players: mockPlayers.table1,
    spectators: [mockUsers.visitante1],
    maxPlayers: 6,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    status: "waiting",
    needsSync: false,
  },
  {
    id: 2,
    name: "PrivTable[123456]",
    owner: "Ana",
    language: "en-US",
    isPrivate: true,
    password: "123456",
    players: mockPlayers.table2,
    spectators: [],
    maxPlayers: 4,
    allowSpectators: false,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    status: "waiting",
    needsSync: false,
  },
  {
    id: 3,
    name: "Dragon Battle",
    owner: "Lucas",
    language: "en-US",
    isPrivate: false,
    password: null,
    players: mockPlayers.table3,
    spectators: [mockUsers.observador1, mockUsers.observador2],
    maxPlayers: 4,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 60).toISOString(),
    status: "playing",
    needsSync: false,
  },
  {
    id: 4,
    name: "Full Table",
    owner: "Player1",
    language: "es-ES",
    isPrivate: false,
    password: null,
    players: mockPlayers.table4,
    spectators: [],
    maxPlayers: 6,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 5).toISOString(),
    status: "waiting",
    needsSync: false,
  },
  {
    id: 5,
    name: "Beginners Welcome",
    owner: "HostPlayer",
    language: "en-US",
    isPrivate: false,
    password: null,
    players: mockPlayers.table5,
    spectators: [],
    maxPlayers: 6,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 2).toISOString(),
    status: "waiting",
    needsSync: false,
  },
  {
    id: 6,
    name: "PrivTable[elite2024]",
    owner: "Elite1",
    language: "pt-BR",
    isPrivate: true,
    password: "elite2024",
    players: mockPlayers.table6,
    spectators: [],
    maxPlayers: 3,
    allowSpectators: false,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 90).toISOString(),
    status: "playing",
    needsSync: false,
  },
  {
    id: 7,
    name: "Completed Journey",
    owner: "Winner1",
    language: "fr-FR",
    isPrivate: false,
    password: null,
    players: mockPlayers.table7,
    spectators: [mockUsers.fan1],
    maxPlayers: 4,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 120).toISOString(),
    status: "finished",
    needsSync: false,
  },
  {
    id: 8,
    name: "Last Spot Available",
    owner: "P1",
    language: "en-US",
    isPrivate: false,
    password: null,
    players: mockPlayers.table8,
    spectators: [mockUsers.spec1, mockUsers.spec2, mockUsers.spec3],
    maxPlayers: 6,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 10).toISOString(),
    status: "waiting",
    needsSync: false,
  },
  {
    id: 9,
    name: "PrivTable[duel]",
    owner: "Duelist1",
    language: "pt-BR",
    isPrivate: true,
    password: "duel",
    players: mockPlayers.table9,
    spectators: [],
    maxPlayers: 2,
    allowSpectators: false,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 45).toISOString(),
    status: "playing",
    needsSync: false,
  },
  {
    id: 10,
    name: "Mega Raid Boss",
    owner: "Raider1",
    language: "zh-CN",
    isPrivate: false,
    password: null,
    players: mockPlayers.table10,
    spectators: [
      mockUsers.fan1,
      mockUsers.fan2,
      mockUsers.fan3,
      mockUsers.fan4,
      mockUsers.fan5,
    ],
    maxPlayers: 8,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 75).toISOString(),
    status: "playing",
    needsSync: false,
  },
  {
    id: 11,
    name: "Paused Table (Break)",
    owner: "ActivePlayer1",
    language: "es-ES",
    isPrivate: false,
    password: null,
    players: mockPlayers.table11,
    spectators: [mockUsers.waitingspec],
    maxPlayers: 5,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 50).toISOString(),
    status: "paused",
    needsSync: false,
  },
  {
    id: 12,
    name: "VIP Waiting Room",
    owner: "OrganizadorHost",
    language: "en-US",
    isPrivate: false,
    password: null,
    players: mockPlayers.table12,
    spectators: [mockUsers.earlybird1, mockUsers.earlybird2],
    maxPlayers: 4,
    allowSpectators: true,
    gameType: "Guild for Glory",
    createdAt: new Date(Date.now() - 1000 * 60 * 3).toISOString(),
    status: "waiting",
    needsSync: false,
  },
];
